import React from 'react';
import { DEFAULT_MULTIVALUE_SEPARATOR } from '../../types';
var getExternalLink = function (link) { return link ? (link.startsWith('http://') || link.startsWith('https://') ? link : 'http://' + link) : ''; };
var getLink = function (link, links) {
    var separator = link !== links[links.length - 1] ? DEFAULT_MULTIVALUE_SEPARATOR : '';
    return React.createElement("a", { key: link, href: getExternalLink(link), target: '_blank' },
        link,
        separator);
};
var HyperlinkCell = function (_a) {
    var value = _a.value;
    var links = !value ? null
        : Array.isArray(value) ? value
            : [value];
    return (React.createElement("div", { className: 'hyperlinkColumnCell' }, !!links && links.map(function (link) { return getLink(link, links); })));
};
export default HyperlinkCell;
//# sourceMappingURL=HyperlinkCell.js.map